import { useLoaderData } from "@remix-run/react";
import { VStack, StackDivider } from "@chakra-ui/react";

import {
  FreeToTrySection,
  HomeHero,
  HowItWorksVideo,
  NotificationProof,
  ReviewSection,
  WhyCancellations,
} from "#app/components/index.jsx";
import { landingLoaderCountry } from "#app/components/landing/landingLoader.server.js";
import { getSeoMeta, getBaseUrl, getDefaultOgImage } from "#app/utils/meta.js";

const COUNTRY = "nz";
// Secondary CTAs pre-scope the request form to this country.
const NEW_PATH = `/new?country=${COUNTRY}`;

const SUBTITLE =
  "Huts, holiday parks, and campsites across New Zealand sell out fast. We monitor the booking systems for cancellations and notify you when a spot opens up.";

export function meta({ matches }) {
  const baseUrl = getBaseUrl(matches);
  return getSeoMeta({
    title: "New Zealand fully booked? Schnerp it!",
    description: SUBTITLE,
    url: `${baseUrl}/nz`,
    image: getDefaultOgImage(baseUrl),
  });
}

export async function loader() {
  return landingLoaderCountry(COUNTRY, { tag: COUNTRY });
}

export default function NewZealand() {
  const { agencyIds, reviews, stats, recentOpenings, alertsSent } =
    useLoaderData();

  return (
    <VStack spacing={{ base: 10, md: 16 }} divider={<StackDivider />}>
      <HomeHero
        heading="DOC hut"
        subtitle={SUBTITLE}
        country={COUNTRY}
        agencyIds={agencyIds}
        reviews={reviews}
        stats={stats}
      />
      <HowItWorksVideo />
      <NotificationProof
        openings={recentOpenings}
        alertsSent={alertsSent}
        ctaTo={NEW_PATH}
      />
      <ReviewSection reviews={reviews} stats={stats} />
      <WhyCancellations />
      <FreeToTrySection ctaTo={NEW_PATH} />
    </VStack>
  );
}
